import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormTextAreaField from '../../../FormFields/FormTextAreaField';
import FormTitle from '../../../FormFields/FormTitle';
import { formCardStyle } from '../../../TransitionStyles';
import { CLINICAL_REIMBURSEMENT } from '../../../formQuestionsEnum';

BeneficiaryNoticeProcessForm.propTypes = {
  permissions: PropTypes.object,
};

export default function BeneficiaryNoticeProcessForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fields = [
    {
      id: CLINICAL_REIMBURSEMENT.BENEFICIARY_NOTICE_PROCESS.id,
      fieldName: CLINICAL_REIMBURSEMENT.BENEFICIARY_NOTICE_PROCESS.fieldName,
      questionTitle: 'Beneficiary notice process',
    },
    {
      id: CLINICAL_REIMBURSEMENT.CARE_PLAN_PROCESS.id,
      fieldName: CLINICAL_REIMBURSEMENT.CARE_PLAN_PROCESS.fieldName,
      questionTitle: 'Care plan process',
    },
    {
      id: CLINICAL_REIMBURSEMENT.WEEKLY_UTILIZATION_REVIEW_PROCESS.id,
      fieldName: CLINICAL_REIMBURSEMENT.WEEKLY_UTILIZATION_REVIEW_PROCESS.fieldName,
      questionTitle: 'Weekly utilization review process',
    },
    {
      id: CLINICAL_REIMBURSEMENT.DISCHARGE_PLANNING_PROCESS.id,
      fieldName: CLINICAL_REIMBURSEMENT.DISCHARGE_PLANNING_PROCESS.fieldName,
      questionTitle: 'Discharge planning process',
    },
  ];

  const showForm = fields.some((field) => field.id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Beneficiary Notice Process
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {fields.map((field) =>
            field.id in permissions ? (
              <Grid item xs={12} key={field.id}>
                <FormTitle fieldAttributes={{ questionTitle: field.questionTitle }} />
                <FormTextAreaField
                  fieldName={field.fieldName}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                  fieldAttributes={{ isEditable: permissions[field.id] }}
                  placeholder="List out the process your facility uses"
                />
              </Grid>
            ) : null
          )}
        </Grid>
      </Card>
    )
  );
}
